Ext.define('SA.SidebarCollapseButton', {
    alias: 'widget.sidebar-collapse-button',
    extend: 'Ext.Component',

    autoEl: {'aria-label': 'collapse sidebar', tag: 'button'},
    cls: 'sa-sidebar-collapse-btn',

    html: [
        '<div class="sa-sidebar-collapse-btn-inner">',
            '<svg aria-hidden="true"><use href="#sa-icon-left-chevrons"></use></svg>',
        '</div>'
    ],

    initEvents() {
        this.callParent();

        this.el.on('click', () => this.fireEvent('click'));
    },

    setCollapsed(collapsed) {
        this.ifCls(collapsed, 'sa-sidebar-collapse-btn-collapsed');
    }
});
